export function setCommunityInfoData(state, payload) {
  return { 
    ...state,
    communityInfo: {
      ...state.communityInfo,
      data: payload
    }
  };
}

export function setCommunityInfoStatus(state, status) {
  return {
    ...state,
    communityInfo: {
      ...state.communityInfo,
      status: status
    }
  };
}